export enum SnackbarType {
    error="error",
    warning="warning",
    info="info",
    success="success"
}